import type { StateCreator } from 'zustand';

// ---------------------------------------------------------------------------
// Types
// ---------------------------------------------------------------------------

export interface StatEntry {
  id: string;
  claim: string;
  value: string;
  value_human: string;
  label: string;
  source: string;
  angle: 'social_proof' | 'contrast' | 'ranking' | 'myth_busting' | 'trend';
  hook_type: 'normalizing' | 'counter_intuitive' | 'fear' | 'aspiration';
  sub_niche: string;
  status: 'pending' | 'approved' | 'rejected';
  added_at: string;
}

export type StatStatusFilter = 'all' | 'pending' | 'approved' | 'rejected';

export interface StatLibrarySlice {
  statLibNiche: string;
  statLibStats: StatEntry[];
  statLibLoading: boolean;
  statLibFilter: StatStatusFilter;
  setStatLibNiche: (niche: string) => void;
  setStatLibStats: (stats: StatEntry[]) => void;
  setStatLibLoading: (loading: boolean) => void;
  setStatLibFilter: (filter: StatStatusFilter) => void;
  updateStatLibEntry: (statId: string, status: StatEntry['status']) => void;
  removeStatLibEntry: (statId: string) => void;
}

// ---------------------------------------------------------------------------
// Slice
// ---------------------------------------------------------------------------

export const createStatLibrarySlice: StateCreator<StatLibrarySlice> = (set) => ({
  statLibNiche: 'ad-fraud',
  statLibStats: [],
  statLibLoading: false,
  statLibFilter: 'all',

  setStatLibNiche: (niche) => set({ statLibNiche: niche }),
  setStatLibStats: (stats) => set({ statLibStats: stats }),
  setStatLibLoading: (loading) => set({ statLibLoading: loading }),
  setStatLibFilter: (filter) => set({ statLibFilter: filter }),

  updateStatLibEntry: (statId, status) =>
    set((state) => ({
      statLibStats: state.statLibStats.map((s) =>
        s.id === statId ? { ...s, status } : s
      ),
    })),

  removeStatLibEntry: (statId) =>
    set((state) => ({
      statLibStats: state.statLibStats.filter((s) => s.id !== statId),
    })),
});
